import React, { useEffect, useState } from "react";
import ReactModal from 'react-modal';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from "react-router-dom";

const SessionTimeout = (props) => {
    const { countdownSeconds, idleTimeOutMilSeconds, isAuthenticated, resetIdleTimer } = props;
    const [timeoutCountdownMessage, setTimeoutCountdownMessage] = useState("");
    const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);

    const navigate = useNavigate();

    const keepWorking = () => {
        setTimeoutModalOpen(false);
        setTimeoutCountdownMessage("");
        idleTimer.reset();
    }

    const handleLogout = () => {
        setTimeoutModalOpen(false);
        setTimeoutCountdownMessage("");
        idleTimer.reset();
        navigate("/Logout");
    }

    const idleTimer = useIdleTimer({
        timeout: idleTimeOutMilSeconds, //Time before onPrompt is triggered (modal pops up)
        promptTimeout: (countdownSeconds + 1) * 1000, //Time before onIdle is triggered - keep 1 second longer than countdown
        onIdle: () => { if (isAuthenticated) handleLogout(); },
        onPrompt: () => { if (isAuthenticated) setTimeoutModalOpen(true); },
        debounce: 500
    });

    useEffect(() => {
        idleTimer.reset();
    }, [resetIdleTimer]);

    useEffect(() => {
        if (timeoutModalOpen) {
            const countdownInterval = setInterval(() => {
                const secondsRemaining = Math.floor(idleTimer.getRemainingTime() / 1000);
                if (secondsRemaining > 0) {
                    const minutes = Math.floor(secondsRemaining / 60);
                    const seconds = secondsRemaining - (minutes * 60);
                    const minutesMessage = minutes === 1 ? 'minute' : 'minutes';
                    const secondsMessage = seconds === 1 ? 'second' : 'seconds';
                    const countDownMessage = minutes === 0
                        ? `${seconds} ${secondsMessage}`
                        : `${minutes} ${minutesMessage} ${seconds} ${secondsMessage}`;
                    setTimeoutCountdownMessage(countDownMessage);
                }
            }, 200);

            return () => clearInterval(countdownInterval);
        }
    }, [timeoutModalOpen]);

    return (
        timeoutModalOpen
            ? <ReactModal
                isOpen={!!timeoutCountdownMessage}
                appElement={document.getElementById('root')}
                className={"timer-cover"}
                overlayClassName={"timer-popup"}
                shouldFocusAfterRender={true}
                shouldReturnFocusAfterClose={true}
                role={"timer"}
            >
                <div className="timer-content icon">
                    <span className="timer-icon" aria-hidden="true"></span>
                    <p className="visually-hidden" role="alert">Your session is about to expire in 2 minutes. Use the buttons to keep working or log out now</p>
                    <p aria-hidden="true">
                        Your session is about to expire in <br /><span id="timeoutCountDown">{timeoutCountdownMessage}</span>
                    </p>
                    <p aria-hidden="true">
                        Do you want to keep working?
                    </p>
                    <button id="btnKeepWorking" className="keep-editing" onClick={keepWorking}>Keep Working</button>
                    <button id="btnLogout" className="leave" onClick={handleLogout}>Log out</button>
                </div>

            </ReactModal>
            : null
    );
}
export default SessionTimeout;